import { FundsAppContext } from "@features/context";

import React, { useContext } from "react";

import Confirmation from "@appComponents/Confirmation/Confirmation";
import EmailIcon from "./checkEmail.svg";

const ConfirmEmail = () => {
  const { appLink } = useContext(FundsAppContext);

  return (
    <Confirmation
      data={{
        title: "One more step",
        texts: ["Please check your email to confirm the withdrawal."],
        link1: {
          text: "Back to Funds",
          url: appLink,
          onClick: () => {
            window.location.href = appLink;
          },
        },
      }}
      icon={<EmailIcon style={{ margin: "0px auto 20px" }} />}
    />
  );
};

export default ConfirmEmail;
